import styled from 'styled-components';
import Wra12A from 'dc/Wra12A';
import Lab117 from 'dc/Lab117';
import { Typ10 } from 'dc/Typ';

type WrapperProps = {
  $center?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  height: 48px;
  width: 100%;
  display: flex;
  background-color: transparent;
  ${props => (props.$center ? 'justify-content: center;' : null)};
`;

type ButtonProps = {
  $split?: boolean;
};

export const Button = styled.button<ButtonProps>`
  position: relative;
  display: inline-flex;
  align-items: center;
  background: transparent;
  border: none;
  outline: none;
  padding: 0;
  margin-right: ${props => (props.$split ? '0' : '16px')};
  ${props => (props.$split ? 'margin-left: auto;' : null)} &:disabled {
    opacity: 0.5;
  }
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};

  &:hover > div > span > i,
  &:hover > div > span > span {
    color: ${props => (props.disabled ? '#90A4AE' : '#00AB97')};
  }
`;

export const NotificationWrapper = styled.div`
  padding: 0 2px;
  position: absolute;
  top: 4px;
  left: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 17px;
  height: 17px;
  background: #d32e2e;
  border-radius: 8.5px;
`;

export const NotificationNumber = styled(Typ10)`
  color: #fff;
`;

type LabelWrapperProps = {
  $selected?: boolean;
  $split?: boolean;
};

export const LabelWrapper = styled(Wra12A)<LabelWrapperProps>`
  ${props => props.$selected && 'border-bottom: 2px solid #00AB97;'};
  ${props => props.$split && 'margin-right: 16px;'};
  ${props => props.$split && 'margin-left: auto;'};
`;

type LabelProps = {
  $selected?: boolean;
};

export const Label = styled(Lab117)<LabelProps>`
  > i,
  > span {
    ${props => (props.selected ? 'color: #00AB97;' : null)};
  }
`;
